import React from 'react';
import { connect } from 'react-redux';
import { Modal, Dimmer, Loader, Table } from 'semantic-ui-react';
import styled from 'styled-components';
import { getBasketData, hideBasket } from '../../actions/basket';

const BasketModal = React.memo(
  ({ products, isLoadingBasketData, getBasketData, hideBasket, isShowBasket, complex }) => {
    React.useEffect(() => {
      getBasketData(complex.id, complex.startDate);
    }, [complex]);

    if (isLoadingBasketData) {
      return (
        <Dimmer active>
          <Loader />
        </Dimmer>
      );
    }
    return (
      <Modal open={isShowBasket} onClose={hideBasket} size="small" closeIcon>
        <BasketModalBlock>
          <Table celled>
            <Table.Header>
              <Table.Row>
                <Table.HeaderCell>Продукт</Table.HeaderCell>
                <Table.HeaderCell>Количество</Table.HeaderCell>
              </Table.Row>
            </Table.Header>
            <Table.Body>
              {products.map((product) => {
                const productName = product.quantity !== 0 ? product.quantity : '';
                return (
                  <Table.Row key={product.id}>
                    <Table.Cell>{product.name}</Table.Cell>
                    <Table.Cell>{`${productName} ${product.measure}`}</Table.Cell>
                  </Table.Row>
                );
              })}
            </Table.Body>
          </Table>
        </BasketModalBlock>
      </Modal>
    );
  },
);

const mapStateToProps = (state) => {
  const { products, isLoadingBasketData, isShowBasket } = state.basket;

  return {
    products,
    isLoadingBasketData,
    isShowBasket,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getBasketData: (complexId, complexStartDate) => {
      dispatch(getBasketData(complexId, complexStartDate));
    },
    hideBasket: () => {
      dispatch(hideBasket());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(BasketModal);

const BasketModalBlock = styled.div`
  width: 100%;
  background-color: white;
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  border: 1px solid black;
  padding: 10px;
`;



// WEBPACK FOOTER //
// ./src/Components/BasketModal/index.js